import * as types from './types';
const getters = {
  [types.INTERNET_COMMERCE_ING_LIST]: state => state.internetCommerceIngList,
  [types.INTERNET_COMMERCE_END_LIST]: state => state.internetCommerceEndList,
  [types.INTERNET_COMMERCE_DETAIL]: state => state.internetCommerceDetail,
  [types.INTERNET_COMMERCE_USER_QUOTATION]: state =>
    state.internetCommercUserQuotationList,
  [types.INTERNET_COMMERCE_USER_QUOTATION_NEW]: state =>
    state.internetCommercUserQuotationNewList,
  [types.INTERNET_COMMERCE_QUOTATION_ING_LIST]: state =>
    state.internetCommerceQuotationIngList,
  [types.INTERNET_COMMERCE_QUOTATION_END_LIST]: state =>
    state.internetCommerceQuotationEndList,
  [types.INTERNET_COMMERCE_QUOTATION_CNT_CHECK]: state =>
    state.internetCommerceQuotationCntCheck,
  [types.INTERNET_COMMERCE_APPLY_DETAIL]: state =>
    state.internetCommerceApplyDetail,
  [types.INTERNET_COMMERCE_APPLY_LIST]: state =>
    state.internetCommerceApplyList,
  [types.INTERNET_COMMERCE_APPLY_NEW_COUNT]: state =>
    state.internetCommerceApplyNewCount,
  [types.INTERNET_COMMERCE_FORECAST]: state => state.internetCommerceForecast,
  [types.INTERNET_CHAT_QUOTATION_LIST]: state =>
    state.internetChatQuotationList,
};

export default getters;
